import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { ProjectCategory } from '../../entities/project-category';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class ProjectCategoryService {

  private static readonly projectCategoryBaseUrl:string = `${Settings.apiUrl}/v1/ProjectCategories`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  public projectCategories:ProjectCategory[] = [];

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getProjectCategories():Promise<ProjectCategory[]>{

    return this.cachedCallService.invokeSingleCall(
      () => {
        let oDataBuilder:ODataBuilder = new ODataBuilder(ProjectCategoryService.projectCategoryBaseUrl);

        //TODO:  Add sort order?
        // oDataBuilder
        //   .orderBy("SortOrder");

        let projectCategoryUrl:string = oDataBuilder.toString();

        return this.http.get(projectCategoryUrl)
                .toPromise()
                .then(response => {
                  this.projectCategories = response.json().value;

                  return this.projectCategories;
                });
      }, "getProjectCategories"
    );
    
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/project-category.service.ts